import React, { useEffect, useState, useMemo } from 'react'

import { FormElementWrapper, Toggle } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { shape, bool, func, string } from 'prop-types'

import WithListingPageContext from 'Pods/ListingPage/Components/WithListingPageContext'
import i18n from 'Pods/Shared/I18n'

import useBreakpoint from 'Utils/useBreakpoint'

import getToggles from './Static/getToggles'

function RemainingCardVisibilitySettings({
  saveCardVisibilitySettings,
  cardVisibilitySettings: initialCardVisibilitySettings,
  showCgtVerification,
  locale = 'en',
}) {
  const currentBreakpoint = useBreakpoint()
  const isMobile = ['xs'].includes(currentBreakpoint)
  const [cardVisibilitySettings, setCardVisibilitySettings] = useState({})
  const cardVisibilityLabel = i18n.t('listingPage.filters.cardVisibility', { ns: 'rails', lng: locale })

  const toggles = useMemo(
    () => getToggles(showCgtVerification, isMobile, locale),
    [showCgtVerification, isMobile, locale]
  )

  useEffect(() => {
    setCardVisibilitySettings(initialCardVisibilitySettings)
  }, [initialCardVisibilitySettings])

  function handleChange(key) {
    setCardVisibilitySettings((state) => {
      const newCardVisibilitySettings = { ...state, [key]: !state[key] }
      saveCardVisibilitySettings(newCardVisibilitySettings)

      return newCardVisibilitySettings
    })
  }

  function renderSettings() {
    return toggles.map(({ key, value }) => (
      <Toggle
        key={key}
        id={key}
        label={value}
        isChecked={cardVisibilitySettings[key]}
        defaultChecked={cardVisibilitySettings[key]}
        onChange={() => handleChange(key)}
        labelClassName="remaining-filters__card-visibility-toggle"
      />
    ))
  }

  return (
    <div className="remaining-filters__card-visibility">
      <FormElementWrapper title={cardVisibilityLabel} withTitleDivider>
        {renderSettings()}
      </FormElementWrapper>
    </div>
  )
}

RemainingCardVisibilitySettings.propTypes = {
  saveCardVisibilitySettings: func.isRequired,
  cardVisibilitySettings: shape({
    type: bool.isRequired,
    price: bool.isRequired,
    format: bool.isRequired,
    quickActionsOnHover: bool.isRequired,
    cgtStandard: bool.isRequired,
  }).isRequired,
  showCgtVerification: bool.isRequired,
  locale: string,
}

const mapStateToProps = ({ saveCardVisibilitySettings, cardVisibilitySettings, showCgtVerification, locale }) => {
  return {
    saveCardVisibilitySettings,
    cardVisibilitySettings,
    showCgtVerification,
    locale,
  }
}

export default WithListingPageContext(mapStateToProps)(RemainingCardVisibilitySettings)
